export default "__VITE_ASSET__bd81dfbe__"